<template>
  <div class="mp-guide-popup">
    <div class="popup">
      <div class="popup-header">
        <div class="popup-logo">
          <img class="didi-logo" src="https://ut-static.udache.com/webx/ut/G3LlnA7A8nvYEJmpbUu8Y.png" />
        </div>
      </div>
      <div class="popup-content">
        <p class="tips">在“滴滴小程序”中打开此页</p>
        <wx-open-launch-weapp
          class="wx-launch-weapp-btn"
          username="gh_7a5c4141778f"
          :path="path"
        >
          <script type="text/wxtag-template">
            <style>
              .mp-popup-btn {
                width: 180px;
                height: 50px;
                background-image: linear-gradient(135deg, #FC5939 0%, #FE5A3F 21%, #FF121A 100%);
                border-radius: 25px;
                color: #ffffff;
                font-size: 18px;
                text-align: center;
                line-height: 50px;
                display: block;
                margin: 0 auto;
              }
            </style>
            <button class="mp-popup-btn">点击查看</button>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>
  </div>
</template>

<script>
import { build, query, hashQuery, buildSearch} from '@didi/webx-js'
import { findPageDef } from '../../webx/global_env/checkParams'
import { TechPageErrorIsLongUrl } from '@/lib/webx/tech_error_track'
import { getExtraInfoOnQuery } from '../util.js'

export default {
  created() {
    const queryInfo = Object.assign({}, query(), hashQuery())
    const pathDef = findPageDef()
    // 当前页面通用赤兔短链跳转到长链时，跳转到封皮页面
    if (pathDef && pathDef.shortLinkFlag && queryInfo.dchn) {
      const extraInfo = getExtraInfoOnQuery()
      const params = {
        dchn: queryInfo.dchn,
        ...extraInfo
      }
      // pathDef.requiredQueryField.forEach(item => {
      //   if (queryInfo[item]) {
      //     params[item] = queryInfo[item]
      //   }
      // })
      
      const queryKeys = [
        // 透传必要参数
        ...(pathDef.requiredQueryField || []),
        // 透传允许的参数
        ...(pathDef.allowQueryField || []),
      ]
      queryKeys.forEach(item => {
        if (queryInfo[item]) {
          params[item] = queryInfo[item]
        }
      })
      this.path = `/pages/index/index${buildSearch(params)}`
    } else {
      const url = build(window.location.href, {
        xenv: 'wxmp',
        from: 'xwebapp'
      })
      TechPageErrorIsLongUrl()
      // zs: 此原生页面不会拼接token\cityid
      this.path = `/webx-mp-next/webview/normal-delta/index?url=${encodeURIComponent(url)}`
    }
    console.log('【path】:', this.path)
  },
  data() {
    return {
      path: '/pages/index/index'
    }
  }
}
</script>

<style lang="stylus" scoped>
.mp-guide-popup
  width 100vw
  height 100vh
  position fixed
  top 0
  left 0
  z-index 9000
  background-color rgba(0, 0, 0, .6)
.popup
  width 500rpx
  height 640rpx
  background #fff
  position fixed
  top 50%
  left 50%
  margin -320rpx 0 0 -250rpx
  border-radius 40rpx
  overflow hidden
.popup-header
  width 500rpx
  height 350rpx
  background-image linear-gradient(132deg, rgb(255, 140, 35) 0%, rgb(248, 100, 23) 86%)
.popup-logo
  width 500rpx
  height 350rpx
  box-sizing border-box
  padding-top 40rpx
  background-image url("https://static.udache.com/webx-h5-static/webx-launch-app/img/default-logo-bg.b4b7794b.png")
  background-size 100% 100%
.didi-logo
  display block
  width 220rpx
  height 66rpx
  margin 0 auto
.tips
  font-size 32rpx
  text-align center
  color #444
  margin 20rpx auto
.wx-launch-weapp-btn
  display block
  margin 64rpx auto
</style>
